import Axios from "axios";
import { _config } from "./httpreq";

const http = Axios.create({
  baseURL: "http://127.0.0.1:8080",
  headers: {
    "content-type": "application/json"
  }
});

http.interceptors.request.use((cfg) => {
  if (window.token) {
    cfg.headers["x-access-token"] = window.token;
    cfg.baseURL = `http://${_config.serverip}:${_config.serverport}`;
  }
  return cfg;
});

http.interceptors.response.use(
  ({ data }) => Promise.resolve(data),
  (error) => {
    const err_msg = (error.response && error.response.error) || error.message;
    return Promise.reject(err_msg);
  }
);

export const exportData = (records, output) => {
  return http.post("/export", {
    records,
    output
  });
};

export const checkImport = (data) => {
  return http.post("/checkImport", data);
};

export const checkPid = (data) => {
  return http.post("/checkPid", data);
};



// WEBPACK FOOTER //
// ./src/services/export.js